import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=0b49eb6c&"
import script from "./newPassword.vue?vue&type=script&lang=js&"
export * from "./newPassword.vue?vue&type=script&lang=js&"
import style0 from "./newPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports